import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Card,
  CardMedia,
  Typography,
  CircularProgress,
} from '@mui/material';

import banner from '../assets/banner.png';

export default function Certificates() {
  const [certificates] = useState([
    'aadhar',
    'apeda',
    'fssai',   
    'gmp',
    'halal',
    'iso',
    'msme',
    'nop',
    'spices',
    'usda'
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  });


  return (
    <Box sx={{ py: 6 }}>
      <Container>
        {/* App BANNER */}
        <Box
          sx={{
            height: { xs: 300, md: 420 },
            backgroundImage: `linear-gradient(
                    rgba(0,0,0,0.45),
                    rgba(0,0,0,0.45)
                  ), url(${banner})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            display: 'flex',
            alignItems: 'center',
            mb: 4,
          }}
        >
          <Container>
            <Typography variant="h3" color="#fff" fontWeight={700}>
              Certificates
            </Typography>
            <Typography
              variant="h6"
              color="#f5e6d3"
              sx={{ mt: 1, maxWidth: 500 }}
            >
              Quality Backed by Certification
            </Typography>
          </Container>
        </Box>


        {/* LOADING / ERROR / EMPTY STATES */}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        )}

        {/* Certificates GRID */}
        {!loading && certificates.length > 0 && (
          <Grid container spacing={4}>
            {certificates.map((product, index) => (
              <Grid item xs={12} sm={6} md={4} key={`certificate-${index}`}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: '0.3s',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      boxShadow: '0 14px 28px transparent',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    image={`/assets/media/certificates/${product}.png`}
                    alt={`certificate-${index}`}
                    sx={{ objectFit: 'cover' }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
}
